import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import type { DriverRow, TagDefinition } from "@/types/driver";
import type { DriverRouteSummary } from "@/types/driverRoute";
import { ContextSection, contextFieldGridSx } from "./ContextBlock";
import DriverField from "./DriverField";
import LocationField from "./LocationField";
import PtaField from "./PtaField";
import TruckAssignmentField from "./TruckAssignmentField";

/**
 * The Info section: who the driver is and what they run, then when and where they free up, as a 2x2 of fields —
 * Driver beside Truck Assignment, PTA beside Location — split by hairlines, stacking once the panel is too narrow
 * for two columns.
 */
export default function InfoBlock({
  driver,
  tags,
  route,
  now,
}: {
  driver: DriverRow;
  tags: readonly TagDefinition[];
  route: DriverRouteSummary | null;
  now: number;
}) {
  return (
    <ContextSection
      icon={<InfoOutlinedIcon sx={{ fontSize: 18 }} />}
      title="Info"
      testId={TestIds.dispatch.contextInfo}
    >
      <Box sx={contextFieldGridSx}>
        <DriverField driver={driver} tags={tags} />
        <TruckAssignmentField driver={driver} tags={tags} route={route} />
        <PtaField route={route} now={now} />
        <LocationField driver={driver} />
      </Box>
    </ContextSection>
  );
}
